import { Table, TablePaginationConfig } from "antd";
import type { JSX } from "react";

import styles from "./index.module.css";

export type PropsTableV2 = {
  columns: Array<{
    key: string;
    title: string | number | JSX.Element;
    dataIndex: string;
  }>;
  pagination?: false | TablePaginationConfig;
  dataSource: Array<any>;
  headerShow?: boolean;
  loading?: boolean;
  className?: string;
};

export const TableAntdV2 = ({
  columns,
  dataSource,
  headerShow = true,
  pagination = false,
  className,
  loading,
}: PropsTableV2) => {
  return (
    <div className={styles.container}>
      <Table
        showHeader={headerShow}
        columns={columns}
        dataSource={dataSource}
        className={`${styles.table}${className ? " " + className : ""}`}
        pagination={pagination}
        loading={loading}
      />
    </div>
  );
};
